'use strict';

module.exports = require('./components/DocEditor/InputBlock').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/InputBlock.js
// module id = 1829
// module chunks = 0